export const getNotificationsList = ({ notifications }) =>
  notifications.list.data.items;

export const getNotificationsCount = ({ notifications }) =>
  notifications.list.data.count;

export const getNotificationsUnreadCount = ({ notifications }) =>
  notifications.list.data.unreadCount;

export const getIsLoadingList = ({ notifications }) =>
  notifications.list.isLoading;

export const getPaginationOptions = ({ notifications }) =>
  notifications.list.paginationOptions;
